/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import BootstrapTable, { SelectRowProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { getPageSize } from 'utils/common';
import { useManagerRole } from 'hooks/role';
import { useDealerPageSize } from 'hooks/pageSize';
import { getColumns } from './columns';
import { ICustomerItem } from '../Models';

interface ICustomersListView {
  customerData: ICustomerItem[];
  selectedCustomer?: ICustomerItem;
  handleOnSelect: (row: any) => void;
  hideColumns?: { [key: string]: boolean };
}

export const DealerCustomersListView = ({
  customerData = [],
  handleOnSelect,
  selectedCustomer,
  hideColumns,
}: ICustomersListView) => {
  const { SearchBar } = Search;
  const isManager = useManagerRole();
  const dealerPageSize = useDealerPageSize();
  const [pageSize] = useState<number>(
    isManager ? +getPageSize() : +dealerPageSize
  );
  // Function to change row color on selection
  const customRowHighlighter = (row: any) =>
    row.dealerCustomerId === selectedCustomer?.dealerCustomerId
      ? 'row-highlight'
      : '';

  const selectRow: SelectRowProps<any> = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectColumn: true,
    onSelect: (row: any) => {
      handleOnSelect(row);
    },
  };

  return (
    <ToolkitProvider
      keyField="dealerCustomerId"
      data={customerData}
      columns={getColumns(hideColumns || {})}
      search
    >
      {(props) => (
        <div>
          <SearchBar
            {...props.searchProps}
            className="custome-search-field form-control-bordered"
            style={{ color: 'grey' }}
            delay={1000}
            placeholder="Search! "
          />
          <hr />
          <BootstrapTable
            {...props.baseProps}
            selectRow={selectRow}
            rowClasses={customRowHighlighter}
            pagination={paginationFactory({
              sizePerPage: pageSize,
              hidePageListOnlyOnePage: true,
            })}
            wrapperClasses="table-dealer-content"
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

DealerCustomersListView.defaultProps = {
  selectedCustomer: undefined,
  hideColumns: {},
};
